import {Component, OnInit} from '@angular/core';
import {MapSidebarFilterService} from './map-sidebar-filter.service';
import {UserDomainService} from '../../user-domains/user-domain.service';
import {UserDomain} from 'shared';

@Component({
  selector: 'app-map-sidebar-filter',
  templateUrl: './map-sidebar-filter.component.html',
  styleUrls: ['./map-sidebar-filter.component.scss']
})
export class MapSidebarFilterComponent implements OnInit {
  domains: any[];

  constructor(public sideFilter: MapSidebarFilterService,
              private userDomainsService: UserDomainService,
  ) {

    // User domains
    this.domains = userDomainsService.domains;
  }

  ngOnInit(): void {
  }

  apply = () => {
    this.sideFilter.apply();
  }

  reset = () => {
    this.sideFilter.reset();
  }
}
